module.exports = __webpack_public_path__ + "static/urban6-9d1656afc94aa3d3ef1a7d748ed1be84.jpg";